module.exports = __webpack_public_path__ + "img/icon-myfolder-white.bdb2651.svg";